import { handleActions } from 'redux-actions';
import {
  openCancelReservationScreen, closeCancelReservationScreen,
  fetchingReservation, fetchingReservationFailed, reservationReceived,
  cancellingReservation, cancellingReservationFailed, reservationCancelled,
  reservationAlreadyCancelled
} from '../actions/cancelling';
import { clearSessionSuccess } from '../actions/session';

const initialState = {
  showCancelReservationScreen: false,
  fetchingReservation: false,
  fetchingReservationError: '',
  reservation: {},
  cancellingReservation: false,
  cancellingReservationError: '',
  reservationCancelled: false,
  reservationAlreadyCancelled: false
};

const cancellingReducer = handleActions({
  [openCancelReservationScreen]: state => ({
    ...state,
    showCancelReservationScreen: true
  }),
  [closeCancelReservationScreen]: state => initialState,
  [fetchingReservation]: state => ({
    ...state,
    fetchingReservationError: initialState.fetchingReservationError,
    fetchingReservation: true
  }),
  [fetchingReservationFailed]: (state, action) => ({
    ...state,
    fetchingReservation: false,
    fetchingReservationError: action.payload
  }),
  [reservationReceived]: (state, action) => ({
    ...state,
    fetchingReservation: false,
    reservation: action.payload
  }),
  [cancellingReservation]: state => ({
    ...state,
    cancellingReservationError: initialState.cancellingReservationError,
    cancellingReservation: true
  }),
  [cancellingReservationFailed]: (state, action) => ({
    ...state,
    cancellingReservation: false,
    cancellingReservationError: action.payload
  }),
  [reservationCancelled]: state => ({
    ...state,
    cancellingReservation: false,
    reservationCancelled: true
  }),
  [reservationAlreadyCancelled]: (state, action) => ({
    ...state,
    cancellingReservationError: '',
    fetchingReservation: false,
    reservation: action.payload,
    reservationCancelled: true,
    reservationAlreadyCancelled: true
  }),
  [clearSessionSuccess]: state => initialState
}, initialState);

export default cancellingReducer;



// WEBPACK FOOTER //
// ./src/reducers/cancelling.js